export default {
  admin: 'Admin',
  password: {
    enterNewPassword: 'Enter new password',
    reenterNewPassword: 'Re-enter new password',
    updatePassword: 'Update Password',
    setPassword: 'Set Password',
    min8CharacterMessage: 'Password must be at least 8 characters long',
    passwordSentMessage: 'The password has been sent to {userName} via email.',
    generateNewPassword: 'Generate New Password',
    assignPasswordMessage: 'Assign a password for the user. The user will be required to change this password upon their next login.',
    generateSecurePassword: 'Generate secure password',
    newPassword: 'New Password',
    confirmNewPassword: 'Confirm New Password',
    showPassword: 'Show password',
    passwordHistory: 'Password History',
    passwordUpdatedLog: 'Password Updated by {userName} on {date}.',
    forgotPasswordLog: 'Forgot Password Request was sent by {userName} on {date}.',
  }
}